import { Theme } from '@mui/material/styles';

// ----------------------------------------------------------------------

export default function LinearProgress(theme: Theme) {
  return {
    MuiLinearProgress: {
      styleOverrides: {
        colorPrimary: {
          backgroundColor: theme.palette.primary.lighter,
          '& .MuiLinearProgress-bar': {
            backgroundColor: theme.palette.primary.main,
          }
        },
        colorSecondary: {
          backgroundColor: theme.palette.secondary.lighter,
          '& .MuiLinearProgress-bar': {
            backgroundColor: theme.palette.secondary.light
          }
        }
      }
    }
  };
}
